
export default function TicketsStatisticsBox(props) {
    return (
        <div className=" flex flex-1 flex-col gap-1 justify-center md:min-w-[47%] p-6 items-center rounded-md border">
            <i className={props.iconColor + " text-2xl mb-1"}>{props.icon}</i>
            <h1 className="font-bold text-2xl">{props.number}</h1>
            <p className="text-sm text-gray-500">{props.title}</p>
        </div>
    )
}
